import React, { createContext } from 'react';
import * as reactRouter from 'react-router';
export const RoutingLibContext = createContext(reactRouter);
export const RoutingLibProvider = ({ children, reactRouterLib, }) => {
    return (React.createElement(RoutingLibContext.Provider, { value: reactRouterLib }, children));
};
